import CookiePanel from "./CookiePanel";
import LandingBanner from "./LandingBanner";
import LandingFeatureBlock from "./LandingFeatureBlock";
import "../styles/LandingView.css";

const LandingView = () => {
  return (
    <>
      <CookiePanel />
      <LandingBanner />
      <hr className="landingview-hr"/>
      <LandingFeatureBlock />
    </>
  );
};

export default LandingView;
